/**
 * Utilitários para validação e correção de coordenadas geográficas
 */

/**
 * Valida e corrige coordenadas de um array para formato [lng, lat]
 * @param {Array} coordinates - Array de coordenadas
 * @returns {Array} - Coordenadas corrigidas
 */
export function validateCoordinates(coordinates) {
  if (!coordinates || !Array.isArray(coordinates) || coordinates.length < 2) {
    console.warn('[GeometryService] Coordenadas inválidas:', coordinates);
    return null;
  }

  // Extrai valores das coordenadas
  let [x, y] = coordinates;

  // Valida valores numéricos
  if (isNaN(x) || isNaN(y)) {
    console.warn('[GeometryService] Coordenadas não-numéricas:', coordinates);
    return null;
  }

  // Converte para números caso sejam strings
  x = Number(x);
  y = Number(y);

  return [x, y];
}

/**
 * Valida e corrige recursivamente coordenadas em estruturas multidimensionais
 * @param {Array} coords - Array de coordenadas (pode ser aninhado)
 * @returns {Array} - Array de coordenadas corrigido
 */
export function validateAndFixCoordinates(coords) {
  if (!coords || !Array.isArray(coords)) {
    return null;
  }

  // Caso base: par de coordenadas [x, y]
  if (coords.length === 2 && typeof coords[0] === 'number' && typeof coords[1] === 'number') {
    return validateCoordinates(coords);
  }

  // Caso recursivo: array de coordenadas
  return coords.map((coord) => validateAndFixCoordinates(coord)).filter(Boolean);
}

/**
 * Valida e corrige coordenadas em um objeto GeoJSON
 * @param {Object} geojson - Objeto GeoJSON
 * @returns {Object|null} - GeoJSON com coordenadas corrigidas ou null
 */
export function validateAndFixGeoJSONCoordinates(geojson) {
  if (!geojson || !geojson.type || !geojson.coordinates) {
    return null;
  }

  try {
    const fixedCoords = validateAndFixCoordinates(geojson.coordinates);
    if (!fixedCoords) return null;

    return {
      ...geojson,
      coordinates: fixedCoords,
    };
  } catch (error) {
    console.error('[GeometryService] Erro ao corrigir GeoJSON:', error);
    return null;
  }
}

/**
 * Verifica se uma coordenada é válida (está dentro dos limites razoáveis)
 * @param {number} lon - Longitude
 * @param {number} lat - Latitude
 * @returns {boolean} - Se a coordenada é válida
 */
export function isValidCoordinate(lon, lat) {
  // Verifica se são números
  if (typeof lon !== 'number' || typeof lat !== 'number') return false;
  if (isNaN(lon) || isNaN(lat)) return false;

  // Verifica se estão dentro dos limites globais
  if (Math.abs(lon) > 180 || Math.abs(lat) > 90) return false;

  return true;
}
